import { z } from 'zod';
import type { TFunction } from 'i18next';

export const createUpdateProfileSchema = (t: TFunction) =>
  z.object({
    displayName: z
      .string()
      .min(1, t('settings:errors.displayNameRequired'))
      .max(100, t('settings:errors.displayNameMax', { max: 100 })),
    color: z.string().min(1, t('settings:errors.colorRequired')),
    avatarUrl: z
      .url({ error: t('settings:errors.avatarUrlInvalid') })
      .nullable()
      .optional(),
  });

export type UpdateProfileInput = z.infer<ReturnType<typeof createUpdateProfileSchema>>;

export const DATE_FORMATS = [
  'dd/MM/yyyy',
  'MM/dd/yyyy',
  'yyyy-MM-dd',
  'dd-MM-yyyy',
  'MM-dd-yyyy',
  'dd.MM.yyyy',
  'd MMM yyyy',
] as const;
export const TIME_FORMATS = ['HH:mm', 'HH:mm:ss', 'hh:mm a', 'hh:mm:ss a'] as const;
export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;

export const updatePreferencesSchema = z.object({
  language: z.enum(SUPPORTED_LANGUAGES).nullable().optional(),
  timezone: z.string().nullable().optional(),
  dateFormat: z.enum(DATE_FORMATS).nullable().optional(),
  timeFormat: z.enum(TIME_FORMATS).nullable().optional(),
});

export type UpdatePreferencesInput = z.infer<typeof updatePreferencesSchema>;
